import Vue from 'vue'
import * as types from 'store/mutation-types'

const isPicExist = src =>
  (src || '').startsWith('http://tigerbrokers.cdn.bj.xs3cnc.com/None')

const state = {
  timeline: {
    list: [],
    pagination: {
      hasNext: true,
      page: 0
    }
  }
}

const mutations = {
  [types.APPEND_TO_NEWS_LIST_TIMELINE](
    state,
    { items: news, totalPage, pageCount }
  ) {
    state.timeline.list = state.timeline.list.concat(news)
    state.timeline.pagination.page++
    state.timeline.pagination.hasNext =
      state.timeline.pagination.page < totalPage
  },
  [types.EMPTY_NEWS_LIST_TIMELINE](state) {
    state.timeline.list = []
    state.timeline.pagination.hasNext = true
    state.timeline.pagination.page = 0
  }
}

const getters = {
  newsList(state) {
    return state.timeline.list.map(article => {
      if (!article) {
        return article
      }

      const hasNoPic = isPicExist(article.thumbnail)
      return Object.assign({}, article, {
        _type: 'news',
        _summary: article.summary,
        _date: new Date(article.pubTime).getTime(),
        _from: article.media,
        _pic: hasNoPic ? null : article.thumbnail
      })
    })
  }
}

const actions = {
  loadQuoteNews({ commit, state, getters }, symbols) {
    // 0 < page <= totalPage
    const pageCount = state.timeline.pagination.page + 1
    if (!state.timeline.pagination.hasNext) {
      return Promise.resolve(getters.newsList)
    }
    const params = {
      symbols,
      pageCount,
      lang_content: getters.languageNewsContent
    }
    return Vue.http
      .get('~stockNews/news/list', { params })
      .then(({ data: respData }) => {
        if (respData) {
          commit(types.APPEND_TO_NEWS_LIST_TIMELINE, respData)
        }
        return getters.newsList || []
      })
  },
  emptyQuoteNews({ commit }) {
    commit(types.EMPTY_NEWS_LIST_TIMELINE)
  },
  fetchNewsById({ commit }, [id]) {
    return Vue.http
      .get('~stockNews/v3/news', {
        params: {
          id,
          translation: 'no'
        }
      })
      .then(({ data }) => {
        data._content = data.content
        data.thumbnail = isPicExist(data.thumbnail) && data.thumbnail
        return data
      })
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
